import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import RowActionsMenu from "../UI/RowActionsMenu";
import EmptyState from "../UI/EmptyState";
import SearchBar from "../UI/SearchBar";
import EditSeasonDialog from "./EditSeasonDialog";
import DeleteSeasonDialog from "./DeleteSeasonDialog";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const SeasonsTable = (props) => {
  const navigate = useNavigate();
  const [editRow, setEditRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [search, setSearch] = useState("");

  const rows = props.seasons.map(({ id, name, startDate, endDate, competition }) => ({
    id,
    name,
    startDate,
    endDate,
    competition: competition.name,
  }));

  const seasonsWithPermission = props.seasonsWithPermission.map((s) => s.id);

  if (rows.length === 0) {
    return (
      <EmptyState
        icon={<CalendarMonthIcon />}
        message="No seasons yet."
      />
    );
  }

  const q = search.toLowerCase();
  const filteredRows = rows.filter((row) =>
    row.name.toLowerCase().includes(q)
  );

  const noResults = filteredRows.length === 0;

  return (
    <>
      <SearchBar
        value={search}
        onChange={setSearch}
        placeholder="Search seasons..."
      />
      {noResults ? (
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          No seasons match &ldquo;{search}&rdquo;.
        </Typography>
      ) : (
      <TableContainer
        className="tableContainer"
        data-testid="seasonsTable"
        component={Paper}
        sx={{ overflowX: "auto" }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {seasonsWithPermission.length > 0 && <TableCell sx={{ width: 48, p: 0.5 }} />}
              <TableCell>Name</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>Competition</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows.map((row) => (
              <TableRow
                data-testid={"seasonTableRow" + row.id}
                hover
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 }, cursor: "pointer" }}
                onClick={() => navigate(`/season/${row.id}`)}
              >
                {seasonsWithPermission.length > 0 && (
                  <TableCell sx={{ width: 48, p: 0.5 }} onClick={(e) => e.stopPropagation()}>
                    {seasonsWithPermission.includes(row.id) && (
                      <RowActionsMenu
                        onEdit={() => setEditRow(row)}
                        onDelete={() => setDeleteRow(row)}
                      />
                    )}
                  </TableCell>
                )}
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.startDate}</TableCell>
                <TableCell>{row.endDate}</TableCell>
                <TableCell>{row.competition}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      )}
      {editRow && (
        <EditSeasonDialog
          open
          setOpen={(open) => !open && setEditRow(null)}
          season={editRow}
        />
      )}
      {deleteRow && (
        <DeleteSeasonDialog
          open
          setOpen={(open) => !open && setDeleteRow(null)}
          season={deleteRow}
        />
      )}
    </>
  );
};

export default SeasonsTable;
